import * as React from "react";
import {Icon, Step} from "semantic-ui-react";

export enum UDAStep {
    DerivatesSelectionStep = 1,
    SummaryStep = 2,
    ConfirmStep = 3,
    ResultStep = 4
}

interface UDAStepHeaderProps {
    t: reactI18Next.TranslationFunction;
    activeStep: UDAStep;
}
export const UDAStepHeader = (props: UDAStepHeaderProps) => (
    <Step.Group size={'mini'} className={'width--100Percent'}>
        <Step active={props.activeStep === UDAStep.DerivatesSelectionStep}>
            <Icon name={'pencil'} />
            <Step.Content>
                <Step.Title>{props.t("UPDATE_DRF_ASGN:SELECT_DERIVATES_TT")}</Step.Title>
            </Step.Content>
        </Step>

        <Step active={props.activeStep === UDAStep.SummaryStep}>
            <Icon name={'tasks'} />
            <Step.Content>
                <Step.Title>{props.t("UPDATE_DRF_ASGN:SUMMARY_TT")}</Step.Title>
            </Step.Content>
        </Step>

        <Step active={props.activeStep === UDAStep.ConfirmStep}>
            <Icon name={'checkmark'} />
            <Step.Content>
                <Step.Title>{props.t("UPDATE_DRF_ASGN:CONFIRM_TT")}</Step.Title>
            </Step.Content>
        </Step>

        <Step active={props.activeStep === UDAStep.ResultStep}>
            <Icon name={'info'} />
            <Step.Content>
                <Step.Title>{props.t("UPDATE_DRF_ASGN:RESULT_TT")}</Step.Title>
            </Step.Content>
        </Step>
    </Step.Group>
);



// WEBPACK FOOTER //
// ./src/views/OptionsView/updateDraftAssignments/UDAStepHeader.tsx